import React from 'react';
import { Link } from 'react-router-dom';
import lib3 from '../assets/images/library/lib3.png';

const aboutUsModernStyles = `
  .home-about-section {
    background: #ffffff;
    border-radius: 22px;
    border: 1px solid #e2e8f0;
    padding: 40px 36px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
    margin-bottom: 2rem;
  }

  .home-about-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #e0f2fe;
    color: #0284c7;
    font-size: 0.76rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    padding: 4px 10px;
    border-radius: 12px;
    margin-bottom: 10px;
  }

  .home-about-title {
    font-size: 2.1rem;
    font-weight: 800;
    color: #063547;
    line-height: 1.2;
    margin-bottom: 16px;
    letter-spacing: -0.4px;
  }

  .home-about-desc {
    font-size: 1.02rem;
    color: #475569;
    line-height: 1.7;
    margin-bottom: 22px;
    text-align: justify;
  }

  /* 4 Pillars Metric Grid */
  .home-about-pillars-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin-bottom: 26px;
  }

  .home-about-pillar-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    transition: all 0.2s ease;
  }

  .home-about-pillar-card:hover {
    border-color: #cbd5e1;
    background: #f1f5f9;
    transform: translateY(-2px);
  }

  .home-about-pillar-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #063547;
    color: #7ee8fa;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    flex-shrink: 0;
  }

  .home-about-pillar-title {
    font-size: 1.08rem;
    font-weight: 800;
    color: #063547;
    line-height: 1.2;
    margin-bottom: 2px;
  }

  .home-about-pillar-sub {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.3;
  }

  .btn-about-discover {
    background: linear-gradient(135deg, #063547 0%, #0a4b63 100%);
    color: #ffffff !important;
    border: none;
    border-radius: 10px;
    padding: 12px 24px;
    font-size: 0.94rem;
    font-weight: 700;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 12px rgba(6, 53, 71, 0.2);
    transition: all 0.2s ease;
  }

  .btn-about-discover:hover {
    background: linear-gradient(135deg, #0a4b63 0%, #0bb6d7 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(11, 182, 215, 0.35);
    color: #ffffff !important;
  }

  .home-about-image-wrapper {
    position: relative;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(6, 53, 71, 0.12);
    border: 1px solid #e2e8f0;
  }

  .home-about-img {
    width: 100%;
    height: 100%;
    max-height: 420px;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }

  .home-about-image-wrapper:hover .home-about-img {
    transform: scale(1.02);
  }

  .home-about-floating-badge {
    position: absolute;
    bottom: 20px;
    left: 20px;
    background: rgba(6, 53, 71, 0.9);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(126, 232, 250, 0.35);
    border-radius: 12px;
    padding: 10px 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  }

  .floating-badge-year {
    font-size: 1.4rem;
    font-weight: 900;
    color: #7ee8fa;
    line-height: 1;
  }

  .floating-badge-text {
    font-size: 0.76rem;
    font-weight: 600;
    color: #e2e8f0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1.2;
  }

  @media (max-width: 992px) {
    .home-about-section {
      padding: 28px 20px;
    }
    .home-about-title {
      font-size: 1.65rem;
    }
    .home-about-pillars-grid {
      grid-template-columns: 1fr;
    }
    .home-about-image-wrapper {
      margin-top: 24px;
    }
  }
`;

export default function AboutUs() {
  return (
    <div className="home-about-section">
      <style>{aboutUsModernStyles}</style>

      <div className="row align-items-center g-4">
        {/* Left Text & Metrics Column */}
        <div className="col-lg-6">
          <div className="home-about-badge">
            <i className="fa fa-landmark"></i>
            <span>Academic Heritage & Scholarly Center</span>
          </div>

          <h2 className="home-about-title">
            About Vidyajyoti Library & Research Center
          </h2>

          <p className="home-about-desc">
            The Vidyajyoti Library, holding over 1,34,000 volumes and 228 scholarly journals, stands as a premier center for theological reflection, biblical hermeneutics, and religious studies. It serves not only Vidyajyoti faculty and students, but also research scholars from <strong>Delhi University</strong>, <strong>JNU</strong>, <strong>Jamia Millia Islamia</strong>, and academic institutions across India and abroad.
          </p>

          {/* 4 Pillars Metric Grid */}
          <div className="home-about-pillars-grid">
            <div className="home-about-pillar-card">
              <div className="home-about-pillar-icon">
                <i className="fa fa-book"></i>
              </div>
              <div>
                <div className="home-about-pillar-title">1,34,000+</div>
                <div className="home-about-pillar-sub">Books & Treatises</div>
              </div>
            </div>

            <div className="home-about-pillar-card">
              <div className="home-about-pillar-icon">
                <i className="fa fa-newspaper"></i>
              </div>
              <div>
                <div className="home-about-pillar-title">228+</div>
                <div className="home-about-pillar-sub">Journals & Serials</div>
              </div>
            </div>

            <div className="home-about-pillar-card">
              <div className="home-about-pillar-icon">
                <i className="fa fa-th-large"></i>
              </div>
              <div>
                <div className="home-about-pillar-title">65 Disciplines</div>
                <div className="home-about-pillar-sub">Theology & Philosophy</div>
              </div>
            </div>

            <div className="home-about-pillar-card">
              <div className="home-about-pillar-icon">
                <i className="fa fa-barcode"></i>
              </div>
              <div>
                <div className="home-about-pillar-title">Digital Circulation</div>
                <div className="home-about-pillar-sub">Automated Barcode OPAC</div>
              </div>
            </div>
          </div>

          <Link to="/aboutus" className="btn-about-discover">
            <span>Discover Our Heritage & Archives</span>
            <i className="fa fa-arrow-right"></i>
          </Link>
        </div>

        {/* Right Imagery Column */}
        <div className="col-lg-6">
          <div className="home-about-image-wrapper">
            <img
              src={lib3}
              alt="Vidyajyoti College of Theology Library"
              className="home-about-img"
              onError={(e) => {
                e.target.src = "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=700&auto=format&fit=crop&q=80";
              }}
            />
            <div className="home-about-floating-badge">
              <div className="floating-badge-year">1879</div>
              <div className="floating-badge-text">
                Established Legacy<br />
                Vidyajyoti Delhi
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
